// API configuration
const getApiUrl = () => {
  const url = process.env.REACT_APP_API_URL || 'http://localhost:5001';
  // If it's localhost, ensure we're using HTTP
  if (url.includes('localhost')) {
    return url.replace('https://', 'http://');
  }
  return url;
};

export const API_URL = getApiUrl();

// Auth0 configuration
export const AUTH0_CONFIG = {
  domain: process.env.REACT_APP_AUTH0_DOMAIN,
  clientId: process.env.REACT_APP_AUTH0_CLIENT_ID,
  audience: process.env.REACT_APP_AUTH0_AUDIENCE
};

export const CONFIG = {
  TIMEOUT_MS: 130000,
  MAX_IMAGES: 4,
  IMAGE_SIZE: '1024x1024'
};

// Founder/Admin access configuration
export const FOUNDER_EMAILS = [
  'blatantspace@gmail.com',
  'ben@robin.guide',
  'ty.brandon.johnston@gmail.com'
]; 